import USER from "./User";
import PAGE from "./Page";
import TABLES from "./Tables";

export default {
  USER,
  PAGE,
  TABLES
};
